import { QuoteClassificationData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';

export const quotesClassificationApi = apiResource<QuoteClassificationData>(
	'quote-classifications'
);
